import { HumanObjectTransform } from 'src/app/edit/models/scene-graph-node';
import { Type } from 'class-transformer';

export class SceneGraphNode {
  // Define Types
  @Type(() => HumanObjectTransform)

  // Common Node Properties -----------------------------------------
  objectId?: string; // NOTE: [EM] bad anonymous objects
  displayName: string;
  layer?: number;

  // Group Node Properties ------------------------------------------
  objects?: SceneGraphNode[];

  // Leaf Node Properties -------------------------------------------
  geometryId?: string;
  materialId?: string;
  morphId?: string;
  transformId?: string;
  transform?: HumanObjectTransform;
}
